// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sticky-text-wrap {
  white-space: normal;
}
#sticky-text-wrap *::after {
  content: '';
}
#sticky-text-wrap > span::after {
  content: ' ';
}
#sticky-text-wrap *[class*="afis-icon"]::after {
  content: ' ';
  font-size: 0.666em;
}
#sticky-text-wrap .no-wrap {
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/global/StickyTextWrap.vue","webpack://./StickyTextWrap.vue"],"names":[],"mappings":"AACA;EACC,mBAAA;ACAD;ADDA;EAGE,WAAA;ACCF;ADJA;EAME,YAAA;ACCF;ADPA;EASE,YAAA;EACA,kBAAA;ACCF;ADXA;EAaE,mBAAA;ACCF","sourcesContent":["\n#sticky-text-wrap {\n\twhite-space: normal;\n\t*::after {\n\t\tcontent: '';\n\t}\n\t> span::after {\n\t\tcontent: ' ';\n\t}\n\t*[class*=\"afis-icon\"]::after {\n\t\tcontent: ' ';\n\t\tfont-size: 0.666em;\n\t}\n\t.no-wrap {\n\t\twhite-space: nowrap;\n\t}\n}\n","#sticky-text-wrap {\n  white-space: normal;\n}\n#sticky-text-wrap *::after {\n  content: '';\n}\n#sticky-text-wrap > span::after {\n  content: ' ';\n}\n#sticky-text-wrap *[class*=\"afis-icon\"]::after {\n  content: ' ';\n  font-size: 0.666em;\n}\n#sticky-text-wrap .no-wrap {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
